import type { KeyboardEvent } from 'react';

const isEnter = (event: KeyboardEvent) => event.key === 'Enter' && !event.shiftKey;

/** Ctrl/Cmd + Enter. */
export const isModifiedEnter = (event: KeyboardEvent) => isEnter(event) && (event.ctrlKey || event.metaKey);

/** Enter with no modifier at all. */
export const isPlainEnter = (event: KeyboardEvent) =>
  isEnter(event) && !event.ctrlKey && !event.metaKey && !event.altKey;

/** Whether this key press sends the prompt, given the user's "Enter to send" preference. */
export const isChatSendShortcut = (event: KeyboardEvent, enterToSend: boolean) =>
  enterToSend ? isPlainEnter(event) : isModifiedEnter(event);

/**
 * Types a line break at the caret. Browsers insert nothing for Ctrl/Cmd + Enter, which is the
 * new-line key when Enter sends. `insertText` keeps the undo history and fires `input`.
 */
export const insertLineBreak = (textarea: HTMLTextAreaElement) => {
  textarea.focus();
  if (document.execCommand?.('insertText', false, '\n')) return;
  textarea.setRangeText('\n', textarea.selectionStart, textarea.selectionEnd, 'end');
  textarea.dispatchEvent(new Event('input', { bubbles: true }));
};
